<template>
  <div class="regist-page">
    <v-container>
      <v-row align="center" justify="center">
        <v-col lg="4" md="6">
          <v-card>
            <v-card-text>
              <v-form v-model="valid">
                <v-container>
                  <v-row class="image-logo">
                    <v-col lg="2" md="2" sm="1" cols="1"></v-col>
                    <v-col lg="8" md="8" sm="10" cols="10">
                      <v-img
                        lazy-src="../assets/logo.png"
                        src="../assets/logo.png"
                        height="80"
                      ></v-img>
                    </v-col>
                    <v-col lg="2" md="2" sm="1" cols="1"></v-col>
                  </v-row>
                  <v-row>
                    <v-col lg="1" md="1" sm="1" cols="1"></v-col>
                    <v-col lg="10" md="10" sm="10" cols="10"
                      ><v-divider></v-divider
                    ></v-col>
                    <v-col lg="1" md="1" sm="1" cols="1"></v-col>
                  </v-row>
                  <v-row>
                    <v-col lg="1" md="1" sm="1" cols="1"></v-col>
                    <v-col class="text-center" lg="10" md="10" sm="10" cols="10"
                      ><h2>สมัครใช้บริการ</h2></v-col
                    >
                    <v-col lg="1" md="1" sm="1" cols="1"></v-col>
                  </v-row>
                  <v-row class="data">
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field
                        prepend-inner-icon="mdi-domain"
                        v-model.trim="form.company_name"
                        hide-details="auto"
                        outlined
                        dense
                        label="ชื่อบริษัท/ห้างหุ้นส่วน"
                        :rules="rules.company_name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field
                        prepend-inner-icon="mdi-incognito"
                        v-model.trim="form.taxid"
                        hide-details="auto"
                        outlined
                        dense
                        label="รหัสประจำตัวผู้เสียภาษี"
                        :rules="rules.taxid"
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="12" md="6" lg="6">
                      <v-file-input
                        outlined
                        dense
                        prepend-icon=""
                        accept=".pdf"
                        prepend-inner-icon="mdi-file-document-multiple"
                        hide-details="auto"
                        v-model="cetificate"
                        :rules="rules.cetificate"
                        @change="fileToBase64()"
                        label="หนังสือ ภ.พ.20"
                      ></v-file-input>
                    </v-col> -->
                    <v-col cols="12" sm="12" md="12" lg="6">
                      <v-text-field
                        outlined
                        dense
                        prepend-inner-icon="mdi-cellphone-iphone"
                        hide-details="auto"
                        v-model.trim="form.tel_main"
                        :rules="rules.tel_main"
                        label="เบอร์โทรหลัก"
                        hint="ใส่ตัวเลขไม่ต้องมีขีดกลาง (-)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <v-text-field
                        prepend-inner-icon="mdi-cellphone-message"
                        v-model.trim="form.lineid_main"
                        hide-details="auto"
                        outlined
                        dense
                        label="ไอดีไลน์เบอร์หลัก"
                        :rules="rules.lineid_main"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <v-text-field
                        outlined
                        dense
                        prepend-inner-icon="mdi-cellphone-iphone"
                        hide-details="auto"
                        v-model.trim="form.tel_sub"
                        label="เบอร์โทรสำรอง"
                        hint="ใส่ตัวเลขไม่ต้องมีขีดกลาง (-)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <v-text-field
                        prepend-inner-icon="mdi-cellphone-message"
                        v-model.trim="form.lineid_sub"
                        hide-details="auto"
                        outlined
                        dense
                        label="ไอดีไลน์เบอร์สำรอง"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field
                        prepend-inner-icon="mdi-human-child"
                        v-model.trim="form.contact_name"
                        hide-details="auto"
                        outlined
                        dense
                        label="ชื่อผู้ติดต่อ"
                        :rules="rules.contact_name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-checkbox
                        v-model="checkbox"
                        :label="`เลือกจังหวัดทั้งหมด`"
                      ></v-checkbox>
                      <v-autocomplete
                        :disabled="checkbox"
                        v-model.trim="form.province"
                        :items="provinces"
                        hide-details="auto"
                        prepend-inner-icon="mdi-clipboard-check-multiple"
                        color="blue-grey lighten-2"
                        outlined
                        :rules="rules.province"
                        dense
                        chips
                        small-chips
                        label="จังหวัดที่ต้องการรับข้อมูล (เลือกได้มากกว่า 1 ข้อ)"
                        item-text="name_th"
                        item-value="id"
                        multiple
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            close
                            small
                            class="chip--select-multi"
                            @click:close="removeProvince(data.item)"
                          >
                            {{ data.item.name_th }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content
                              v-text="data.item"
                            ></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content
                              v-html="data.item.name_th"
                            ></v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-autocomplete
                        prepend-inner-icon="mdi-clipboard-check-multiple"
                        v-model.trim="form.type_job"
                        :items="typeworks"
                        item-text="job_type_name"
                        item-value="job_type_id"
                        hide-details="auto"
                        outlined
                        dense
                        chips
                        small-chips
                        label="ประเภทงานที่ต้องการรับข้อมูล (เลือกได้มากกว่า 1 ข้อ)"
                        multiple
                        :rules="rules.typework"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            close
                            small
                            class="chip--select-multi"
                            @click:close="removeType(data.item)"
                          >
                            {{ data.item.job_type_name }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-content
                              v-text="data.item.job_type_name"
                            ></v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-container style="margin-top: 0px; padding-top: 0px">
                <v-row style="margin-top: 0px; padding-top: 0px">
                  <v-col style="margin-top: 0px; padding-top: 0px">
                    <v-btn
                      color="success darken-1"
                      block
                      :disabled="!valid"
                      @click="saveItemComfirm()"
                      >ส่งข้อมูล</v-btn
                    ></v-col
                  >
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="saveDialog" persistent max-width="350px">
      <v-card>
        <v-card-title class="headline">ยืนยันการทำรายการหรือไม่? </v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" small @click="save()">ยืนยัน</v-btn>
          <v-btn small color="error darken-1" text @click="close()"
            >ยกเลิก</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import md5 from "crypto-js/md5";
export default {
  name: "Regist",
  data: () => ({
    checkbox: false,
    valid: false,
    saveDialog: false,
    form: {
      taxid: null,
      company_name: null,
      tel_main: null,
      tel_sub: null,
      lineid_main: null,
      lineid_sub: null,
      typeline_main: null,
      typeline_sub: null,
      province: null,
      type_job: null,
      contact_name: null,
      password_md5: null,
    },
    all: [],
    rules: {
      taxid: [
        (v) => (!!v && v.length == 13) || "กรุณากรอกข้อมูลให้ครบ 13 หลัก",
      ],
      company_name: [(v) => !!v || "กรุณาชื่อบริษัท"],
      tel_main: [
        (v) => (!!v && v.length == 10) || "กรุณากรอกเบอร์โทรให้ครบ 10 หลัก",
      ],
      tel_sub: [
        (v) => (!!v && v.length == 10) || "กรุณากรอกเบอร์โทรให้ครบ 10 หลัก",
      ],
      lineid_main: [(v) => !!v || "กรุณากรอกไลน์ไอดีเบอร์หลัก"],
      lineid_sub: [(v) => !!v || "กรุณากรอกไลน์ไอดีเบอร์สำรอง"],
      province: [(v) => !!v || "กรุณาเลือกจังหวัด"],
      type_job: [(v) => !!v || "กรุณาประเภทงาน"],
      contact_name: [(v) => !!v || "กรุณาระบุชื่อผู้ที่สามารถคติดต่อกลับ"],
    },
    typeworks: [],
    provinces: [],
  }),
  mounted() {
    this.getAllJob();
    this.getAllProvince();
  },
  watch: {
    checkbox(val) {
      !val ? (this.form.province = []) : (this.form.province = this.all);
    },
  },
  methods: {
    save() {
      let md5Hash = md5(this.form.taxid);
      this.form.password_md5 = md5Hash.toString();

      this.$axios.post(this.api + "/new/regist", this.form).then((res) => {
        if (res.data.status) {
          alert("คุณได้สมัครเรียบร้อยเเล้ว กรุณารอการตอบกลับจากทีมงาน");
          location.reload();
        } else {
          if (res.data.error === "Duplicate") {
            alert(
              "คุณเคยสมัครไว้เเล้ว ไม่สามารถสมัครซ้ำได้ กรุณารอการตอบกลับจากทีมงาน"
            );
          } else {
            alert("ไม่สามารถสมัครได้ กรุณาติดต่อทีมงาน");
          }
        }
      });
    },
    close() {
      this.saveDialog = false;
    },
    saveItemComfirm() {
      this.saveDialog = true;
    },
    getAllJob() {
      this.$axios.get(this.api + "/all/typejob").then((res) => {
        if (res.data.status) {
          this.typeworks = res.data.response;
        }
      });
    },
    getAllProvince() {
      this.$axios.get(this.api + "/all/province").then((res) => {
        if (res.data.status) {
          this.all = [];
          this.provinces.push(JSON.parse('{"header": "ทั่วประเทศ"}'));
          this.provinces.push(
            JSON.parse(
              '{"id": "", "group": "ทั่วประเทศ", "name_th": "ทั้งหมด"}'
            )
          );
          for (let index = 0; index < res.data.response.length; index++) {
            this.all.push(res.data.response[index].id);
            if (index === 0) {
              this.provinces.push(JSON.parse('{"header": "ภาคใต้"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 14) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันออก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 21) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันตก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 26) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(
                JSON.parse('{"header": "ภาคตะวันออกเฉียงเหนือ"}')
              );
              this.provinces.push(res.data.response[index]);
            } else if (index === 46) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคกลาง"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 68) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคเหนือ"}'));
              this.provinces.push(res.data.response[index]);
            } else {
              this.provinces.push(res.data.response[index]);
            }
          }
        }
      });
    },
    removeType(item) {
      let index = this.form.type_job.indexOf(item.job_type_id);
      if (index >= 0) this.form.type_job.splice(index, 1);
    },
    removeProvince(item) {
      let index = this.form.province.indexOf(item.id);
      if (index >= 0) this.form.province.splice(index, 1);
    },
  },
};
</script>

<style>
.regist-page {
  height: 100%;
}
</style>
